import React from "react"

/**
 * @type {React.Context<boolean>}
 */
export const Context = React.createContext()

class AdminContextProvider extends React.PureComponent {
  state = { a: undefined }

  componentDidMount() {
    const isAdmin = document.location.search === "?edit"
    if (isAdmin) {
      miBaby.app.StaticContent.configureApplication()
    }

    this.setState({ a: isAdmin })
  }

  render() {
    return (
      <Context.Provider value={this.state.a}>
        {this.props.children}
      </Context.Provider>
    )
  }
}

export const Provider = AdminContextProvider
export const Consumer = Context.Consumer
